<template>
	<ul v-if='shouldShow' class='block-list no-bullet'>
    <li v-for='linkItem in linkItems'>
      <a :href='linkItem.Href'>{{linkItem.Name}}</a>
    </li>
  </ul>
</template>

<script>

export default {
  name: 'top-text-box-link-list',
  data () {
    return {
      linkItems: this.$root.cmsData.mainBlock.linkList
    }
  },
  computed: {
    shouldShow: function () {
      return this.linkItems && this.linkItems.length > 0
    }
  }
}
</script>



// WEBPACK FOOTER //
// TopTextBoxLinkList.vue?78a0d3e1